import { Typography } from '@material-ui/core';
import groupBy from 'lodash/groupBy';
import { PagePermissionEntityInterface } from '@types';
import { FeaturePermissionItem } from '../FeaturePermissionItem';
import { FeaturePermissionGroupItem } from '../FeaturePermissionGroupItem';
import { FeaturePermission, PagePermission, PermissionActions } from '@enums';
import './index.scss';
import { useEffect, useState } from 'react';

interface Props {
  page: PagePermissionEntityInterface;
}

export const PagePermissionItem = ({ page }: Props) => {
  const [groupListFeature, setGroupListFeature] = useState(null);
  useEffect(() => {
    if (page.name === PagePermission.Letters) {
      setGroupListFeature(
        featuresWithoutInstanceKey.find((feature) => feature.name === FeaturePermission.GroupList)
      );
    }
  });
  const featuresWithoutInstanceKey = page.featurePermissions.filter(
    (feature) => !feature.instanceKey
  );
  const featuresInstanceKey = page.featurePermissions.filter((feature) => feature.instanceKey);
  const featuresGroupedByName = Object.entries(groupBy(featuresInstanceKey, 'name'));

  return (
    <div className="permission-page" data-testid="dt-page-permission">
      <Typography className="permission-page__name">
        {page?.title?.toUpperCase() || page.name.toUpperCase()}
      </Typography>
      {page.description && (
        <Typography className="permission-page__description">{page.description}</Typography>
      )}

      <div className="feature-container">
        {featuresGroupedByName.map((feature, index) => (
          <FeaturePermissionGroupItem
            name={feature[0]}
            features={feature[1]}
            title={feature[1][0].title}
            description={feature[1][0].description}
            key={`${feature[0]}-${index}`}
            externalFeature={groupListFeature}
          />
        ))}
        {featuresWithoutInstanceKey.map(
          (feature, index) =>
            feature[PermissionActions.View] && (
              <FeaturePermissionItem
                feature={feature}
                key={`${feature.name}-${feature.instanceKey}-${index}`}
              />
            )
        )}
      </div>
    </div>
  );
};
